@theme {
  --color-nsw-grey-50: var(--nsw-grey-50);
  --color-nsw-grey-100: var(--nsw-grey-100);
  --color-nsw-grey-150: var(--nsw-grey-150);
  --color-nsw-grey-200: var(--nsw-grey-200);
  --color-nsw-grey-250: var(--nsw-grey-250);
  --color-nsw-grey-300: var(--nsw-grey-300);
  --color-nsw-grey-350: var(--nsw-grey-350);
  --color-nsw-grey-400: var(--nsw-grey-400);
  --color-nsw-grey-450: var(--nsw-grey-450);
  --color-nsw-grey-500: var(--nsw-grey-500);
  --color-nsw-grey-550: var(--nsw-grey-550);
  --color-nsw-grey-600: var(--nsw-grey-600);
  --color-nsw-grey-650: var(--nsw-grey-650);
  --color-nsw-grey-700: var(--nsw-grey-700);
  --color-nsw-grey-750: var(--nsw-grey-750);
  --color-nsw-grey-800: var(--nsw-grey-800);
  --color-nsw-grey-850: var(--nsw-grey-850);
  --color-nsw-grey-900: var(--nsw-grey-900);
  --color-nsw-grey-950: var(--nsw-grey-950);
  --color-nsw-green-50: var(--nsw-green-50);
  --color-nsw-green-100: var(--nsw-green-100);
  --color-nsw-green-150: var(--nsw-green-150);
  --color-nsw-green-200: var(--nsw-green-200);
  --color-nsw-green-250: var(--nsw-green-250);
  --color-nsw-green-300: var(--nsw-green-300);
  --color-nsw-green-350: var(--nsw-green-350);
  --color-nsw-green-400: var(--nsw-green-400);
  --color-nsw-green-450: var(--nsw-green-450);
  --color-nsw-green-500: var(--nsw-green-500);
  --color-nsw-green-550: var(--nsw-green-550);
  --color-nsw-green-600: var(--nsw-green-600);
  --color-nsw-green-650: var(--nsw-green-650);
  --color-nsw-green-700: var(--nsw-green-700);
  --color-nsw-green-750: var(--nsw-green-750);
  --color-nsw-green-800: var(--nsw-green-800);
  --color-nsw-green-850: var(--nsw-green-850);
  --color-nsw-green-900: var(--nsw-green-900);
  --color-nsw-green-950: var(--nsw-green-950);
  --color-nsw-teal-50: var(--nsw-teal-50);
  --color-nsw-teal-100: var(--nsw-teal-100);
  --color-nsw-teal-150: var(--nsw-teal-150);
  --color-nsw-teal-200: var(--nsw-teal-200);
  --color-nsw-teal-250: var(--nsw-teal-250);
  --color-nsw-teal-300: var(--nsw-teal-300);
  --color-nsw-teal-350: var(--nsw-teal-350);
  --color-nsw-teal-400: var(--nsw-teal-400);
  --color-nsw-teal-450: var(--nsw-teal-450);
  --color-nsw-teal-500: var(--nsw-teal-500);
  --color-nsw-teal-550: var(--nsw-teal-550);
  --color-nsw-teal-600: var(--nsw-teal-600);
  --color-nsw-teal-650: var(--nsw-teal-650);
  --color-nsw-teal-700: var(--nsw-teal-700);
  --color-nsw-teal-750: var(--nsw-teal-750);
  --color-nsw-teal-800: var(--nsw-teal-800);
  --color-nsw-teal-850: var(--nsw-teal-850);
  --color-nsw-teal-900: var(--nsw-teal-900);
  --color-nsw-teal-950: var(--nsw-teal-950);
  --color-nsw-blue-50: var(--nsw-blue-50);
  --color-nsw-blue-100: var(--nsw-blue-100);
  --color-nsw-blue-150: var(--nsw-blue-150);
  --color-nsw-blue-200: var(--nsw-blue-200);
  --color-nsw-blue-250: var(--nsw-blue-250);
  --color-nsw-blue-300: var(--nsw-blue-300);
  --color-nsw-blue-350: var(--nsw-blue-350);
  --color-nsw-blue-400: var(--nsw-blue-400);
  --color-nsw-blue-450: var(--nsw-blue-450);
  --color-nsw-blue-500: var(--nsw-blue-500);
  --color-nsw-blue-550: var(--nsw-blue-550);
  --color-nsw-blue-600: var(--nsw-blue-600);
  --color-nsw-blue-650: var(--nsw-blue-650);
  --color-nsw-blue-700: var(--nsw-blue-700);
  --color-nsw-blue-750: var(--nsw-blue-750);
  --color-nsw-blue-800: var(--nsw-blue-800);
  --color-nsw-blue-850: var(--nsw-blue-850);
  --color-nsw-blue-900: var(--nsw-blue-900);
  --color-nsw-blue-950: var(--nsw-blue-950);
  --color-nsw-purple-50: var(--nsw-purple-50);
  --color-nsw-purple-100: var(--nsw-purple-100);
  --color-nsw-purple-150: var(--nsw-purple-150);
  --color-nsw-purple-200: var(--nsw-purple-200);
  --color-nsw-purple-250: var(--nsw-purple-250);
  --color-nsw-purple-300: var(--nsw-purple-300);
  --color-nsw-purple-350: var(--nsw-purple-350);
  --color-nsw-purple-400: var(--nsw-purple-400);
  --color-nsw-purple-450: var(--nsw-purple-450);
  --color-nsw-purple-500: var(--nsw-purple-500);
  --color-nsw-purple-550: var(--nsw-purple-550);
  --color-nsw-purple-600: var(--nsw-purple-600);
  --color-nsw-purple-650: var(--nsw-purple-650);
  --color-nsw-purple-700: var(--nsw-purple-700);
  --color-nsw-purple-750: var(--nsw-purple-750);
  --color-nsw-purple-800: var(--nsw-purple-800);
  --color-nsw-purple-850: var(--nsw-purple-850);
  --color-nsw-purple-900: var(--nsw-purple-900);
  --color-nsw-purple-950: var(--nsw-purple-950);
  --color-nsw-fuchsia-50: var(--nsw-fuchsia-50);
  --color-nsw-fuchsia-100: var(--nsw-fuchsia-100);
  --color-nsw-fuchsia-150: var(--nsw-fuchsia-150);
  --color-nsw-fuchsia-200: var(--nsw-fuchsia-200);
  --color-nsw-fuchsia-250: var(--nsw-fuchsia-250);
  --color-nsw-fuchsia-300: var(--nsw-fuchsia-300);
  --color-nsw-fuchsia-350: var(--nsw-fuchsia-350);
  --color-nsw-fuchsia-400: var(--nsw-fuchsia-400);
  --color-nsw-fuchsia-450: var(--nsw-fuchsia-450);
  --color-nsw-fuchsia-500: var(--nsw-fuchsia-500);
  --color-nsw-fuchsia-550: var(--nsw-fuchsia-550);
  --color-nsw-fuchsia-600: var(--nsw-fuchsia-600);
  --color-nsw-fuchsia-650: var(--nsw-fuchsia-650);
  --color-nsw-fuchsia-700: var(--nsw-fuchsia-700);
  --color-nsw-fuchsia-750: var(--nsw-fuchsia-750);
  --color-nsw-fuchsia-800: var(--nsw-fuchsia-800);
  --color-nsw-fuchsia-850: var(--nsw-fuchsia-850);
  --color-nsw-fuchsia-900: var(--nsw-fuchsia-900);
  --color-nsw-fuchsia-950: var(--nsw-fuchsia-950);
  --color-nsw-red-50: var(--nsw-red-50);
  --color-nsw-red-100: var(--nsw-red-100);
  --color-nsw-red-150: var(--nsw-red-150);
  --color-nsw-red-200: var(--nsw-red-200);
  --color-nsw-red-250: var(--nsw-red-250);
  --color-nsw-red-300: var(--nsw-red-300);
  --color-nsw-red-350: var(--nsw-red-350);
  --color-nsw-red-400: var(--nsw-red-400);
  --color-nsw-red-450: var(--nsw-red-450);
  --color-nsw-red-500: var(--nsw-red-500);
  --color-nsw-red-550: var(--nsw-red-550);
  --color-nsw-red-600: var(--nsw-red-600);
  --color-nsw-red-650: var(--nsw-red-650);
  --color-nsw-red-700: var(--nsw-red-700);
  --color-nsw-red-750: var(--nsw-red-750);
  --color-nsw-red-800: var(--nsw-red-800);
  --color-nsw-red-850: var(--nsw-red-850);
  --color-nsw-red-900: var(--nsw-red-900);
  --color-nsw-red-950: var(--nsw-red-950);
  --color-nsw-orange-50: var(--nsw-orange-50);
  --color-nsw-orange-100: var(--nsw-orange-100);
  --color-nsw-orange-150: var(--nsw-orange-150);
  --color-nsw-orange-200: var(--nsw-orange-200);
  --color-nsw-orange-250: var(--nsw-orange-250);
  --color-nsw-orange-300: var(--nsw-orange-300);
  --color-nsw-orange-350: var(--nsw-orange-350);
  --color-nsw-orange-400: var(--nsw-orange-400);
  --color-nsw-orange-450: var(--nsw-orange-450);
  --color-nsw-orange-500: var(--nsw-orange-500);
  --color-nsw-orange-550: var(--nsw-orange-550);
  --color-nsw-orange-600: var(--nsw-orange-600);
  --color-nsw-orange-650: var(--nsw-orange-650);
  --color-nsw-orange-700: var(--nsw-orange-700);
  --color-nsw-orange-750: var(--nsw-orange-750);
  --color-nsw-orange-800: var(--nsw-orange-800);
  --color-nsw-orange-850: var(--nsw-orange-850);
  --color-nsw-orange-900: var(--nsw-orange-900);
  --color-nsw-orange-950: var(--nsw-orange-950);
  --color-nsw-yellow-50: var(--nsw-yellow-50);
  --color-nsw-yellow-100: var(--nsw-yellow-100);
  --color-nsw-yellow-150: var(--nsw-yellow-150);
  --color-nsw-yellow-200: var(--nsw-yellow-200);
  --color-nsw-yellow-250: var(--nsw-yellow-250);
  --color-nsw-yellow-300: var(--nsw-yellow-300);
  --color-nsw-yellow-350: var(--nsw-yellow-350);
  --color-nsw-yellow-400: var(--nsw-yellow-400);
  --color-nsw-yellow-450: var(--nsw-yellow-450);
  --color-nsw-yellow-500: var(--nsw-yellow-500);
  --color-nsw-yellow-550: var(--nsw-yellow-550);
  --color-nsw-yellow-600: var(--nsw-yellow-600);
  --color-nsw-yellow-650: var(--nsw-yellow-650);
  --color-nsw-yellow-700: var(--nsw-yellow-700);
  --color-nsw-yellow-750: var(--nsw-yellow-750);
  --color-nsw-yellow-800: var(--nsw-yellow-800);
  --color-nsw-yellow-850: var(--nsw-yellow-850);
  --color-nsw-yellow-900: var(--nsw-yellow-900);
  --color-nsw-yellow-950: var(--nsw-yellow-950);
  --color-nsw-brown-50: var(--nsw-brown-50);
  --color-nsw-brown-100: var(--nsw-brown-100);
  --color-nsw-brown-150: var(--nsw-brown-150);
  --color-nsw-brown-200: var(--nsw-brown-200);
  --color-nsw-brown-250: var(--nsw-brown-250);
  --color-nsw-brown-300: var(--nsw-brown-300);
  --color-nsw-brown-350: var(--nsw-brown-350);
  --color-nsw-brown-400: var(--nsw-brown-400);
  --color-nsw-brown-450: var(--nsw-brown-450);
  --color-nsw-brown-500: var(--nsw-brown-500);
  --color-nsw-brown-550: var(--nsw-brown-550);
  --color-nsw-brown-600: var(--nsw-brown-600);
  --color-nsw-brown-650: var(--nsw-brown-650);
  --color-nsw-brown-700: var(--nsw-brown-700);
  --color-nsw-brown-750: var(--nsw-brown-750);
  --color-nsw-brown-800: var(--nsw-brown-800);
  --color-nsw-brown-850: var(--nsw-brown-850);
  --color-nsw-brown-900: var(--nsw-brown-900);
  --color-nsw-brown-950: var(--nsw-brown-950);
  --color-nsw-aboriginal-grey-50: var(--nsw-aboriginal-grey-50);
  --color-nsw-aboriginal-grey-100: var(--nsw-aboriginal-grey-100);
  --color-nsw-aboriginal-grey-150: var(--nsw-aboriginal-grey-150);
  --color-nsw-aboriginal-grey-200: var(--nsw-aboriginal-grey-200);
  --color-nsw-aboriginal-grey-250: var(--nsw-aboriginal-grey-250);
  --color-nsw-aboriginal-grey-300: var(--nsw-aboriginal-grey-300);
  --color-nsw-aboriginal-grey-350: var(--nsw-aboriginal-grey-350);
  --color-nsw-aboriginal-grey-400: var(--nsw-aboriginal-grey-400);
  --color-nsw-aboriginal-grey-450: var(--nsw-aboriginal-grey-450);
  --color-nsw-aboriginal-grey-500: var(--nsw-aboriginal-grey-500);
  --color-nsw-aboriginal-grey-550: var(--nsw-aboriginal-grey-550);
  --color-nsw-aboriginal-grey-600: var(--nsw-aboriginal-grey-600);
  --color-nsw-aboriginal-grey-650: var(--nsw-aboriginal-grey-650);
  --color-nsw-aboriginal-grey-700: var(--nsw-aboriginal-grey-700);
  --color-nsw-aboriginal-grey-750: var(--nsw-aboriginal-grey-750);
  --color-nsw-aboriginal-grey-800: var(--nsw-aboriginal-grey-800);
  --color-nsw-aboriginal-grey-850: var(--nsw-aboriginal-grey-850);
  --color-nsw-aboriginal-grey-900: var(--nsw-aboriginal-grey-900);
  --color-nsw-aboriginal-grey-950: var(--nsw-aboriginal-grey-950);
  --color-nsw-aboriginal-red-50: var(--nsw-aboriginal-red-50);
  --color-nsw-aboriginal-red-100: var(--nsw-aboriginal-red-100);
  --color-nsw-aboriginal-red-150: var(--nsw-aboriginal-red-150);
  --color-nsw-aboriginal-red-200: var(--nsw-aboriginal-red-200);
  --color-nsw-aboriginal-red-250: var(--nsw-aboriginal-red-250);
  --color-nsw-aboriginal-red-300: var(--nsw-aboriginal-red-300);
  --color-nsw-aboriginal-red-350: var(--nsw-aboriginal-red-350);
  --color-nsw-aboriginal-red-400: var(--nsw-aboriginal-red-400);
  --color-nsw-aboriginal-red-450: var(--nsw-aboriginal-red-450);
  --color-nsw-aboriginal-red-500: var(--nsw-aboriginal-red-500);
  --color-nsw-aboriginal-red-550: var(--nsw-aboriginal-red-550);
  --color-nsw-aboriginal-red-600: var(--nsw-aboriginal-red-600);
  --color-nsw-aboriginal-red-650: var(--nsw-aboriginal-red-650);
  --color-nsw-aboriginal-red-700: var(--nsw-aboriginal-red-700);
  --color-nsw-aboriginal-red-750: var(--nsw-aboriginal-red-750);
  --color-nsw-aboriginal-red-800: var(--nsw-aboriginal-red-800);
  --color-nsw-aboriginal-red-850: var(--nsw-aboriginal-red-850);
  --color-nsw-aboriginal-red-900: var(--nsw-aboriginal-red-900);
  --color-nsw-aboriginal-red-950: var(--nsw-aboriginal-red-950);
  --color-nsw-aboriginal-orange-50: var(--nsw-aboriginal-orange-50);
  --color-nsw-aboriginal-orange-100: var(--nsw-aboriginal-orange-100);
  --color-nsw-aboriginal-orange-150: var(--nsw-aboriginal-orange-150);
  --color-nsw-aboriginal-orange-200: var(--nsw-aboriginal-orange-200);
  --color-nsw-aboriginal-orange-250: var(--nsw-aboriginal-orange-250);
  --color-nsw-aboriginal-orange-300: var(--nsw-aboriginal-orange-300);
  --color-nsw-aboriginal-orange-350: var(--nsw-aboriginal-orange-350);
  --color-nsw-aboriginal-orange-400: var(--nsw-aboriginal-orange-400);
  --color-nsw-aboriginal-orange-450: var(--nsw-aboriginal-orange-450);
  --color-nsw-aboriginal-orange-500: var(--nsw-aboriginal-orange-500);
  --color-nsw-aboriginal-orange-550: var(--nsw-aboriginal-orange-550);
  --color-nsw-aboriginal-orange-600: var(--nsw-aboriginal-orange-600);
  --color-nsw-aboriginal-orange-650: var(--nsw-aboriginal-orange-650);
  --color-nsw-aboriginal-orange-700: var(--nsw-aboriginal-orange-700);
  --color-nsw-aboriginal-orange-750: var(--nsw-aboriginal-orange-750);
  --color-nsw-aboriginal-orange-800: var(--nsw-aboriginal-orange-800);
  --color-nsw-aboriginal-orange-850: var(--nsw-aboriginal-orange-850);
  --color-nsw-aboriginal-orange-900: var(--nsw-aboriginal-orange-900);
  --color-nsw-aboriginal-orange-950: var(--nsw-aboriginal-orange-950);
  --color-nsw-aboriginal-brown-50: var(--nsw-aboriginal-brown-50);
  --color-nsw-aboriginal-brown-100: var(--nsw-aboriginal-brown-100);
  --color-nsw-aboriginal-brown-150: var(--nsw-aboriginal-brown-150);
  --color-nsw-aboriginal-brown-200: var(--nsw-aboriginal-brown-200);
  --color-nsw-aboriginal-brown-250: var(--nsw-aboriginal-brown-250);
  --color-nsw-aboriginal-brown-300: var(--nsw-aboriginal-brown-300);
  --color-nsw-aboriginal-brown-350: var(--nsw-aboriginal-brown-350);
  --color-nsw-aboriginal-brown-400: var(--nsw-aboriginal-brown-400);
  --color-nsw-aboriginal-brown-450: var(--nsw-aboriginal-brown-450);
  --color-nsw-aboriginal-brown-500: var(--nsw-aboriginal-brown-500);
  --color-nsw-aboriginal-brown-550: var(--nsw-aboriginal-brown-550);
  --color-nsw-aboriginal-brown-600: var(--nsw-aboriginal-brown-600);
  --color-nsw-aboriginal-brown-650: var(--nsw-aboriginal-brown-650);
  --color-nsw-aboriginal-brown-700: var(--nsw-aboriginal-brown-700);
  --color-nsw-aboriginal-brown-750: var(--nsw-aboriginal-brown-750);
  --color-nsw-aboriginal-brown-800: var(--nsw-aboriginal-brown-800);
  --color-nsw-aboriginal-brown-850: var(--nsw-aboriginal-brown-850);
  --color-nsw-aboriginal-brown-900: var(--nsw-aboriginal-brown-900);
  --color-nsw-aboriginal-brown-950: var(--nsw-aboriginal-brown-950);
  --color-nsw-aboriginal-yellow-50: var(--nsw-aboriginal-yellow-50);
  --color-nsw-aboriginal-yellow-100: var(--nsw-aboriginal-yellow-100);
  --color-nsw-aboriginal-yellow-150: var(--nsw-aboriginal-yellow-150);
  --color-nsw-aboriginal-yellow-200: var(--nsw-aboriginal-yellow-200);
  --color-nsw-aboriginal-yellow-250: var(--nsw-aboriginal-yellow-250);
  --color-nsw-aboriginal-yellow-300: var(--nsw-aboriginal-yellow-300);
  --color-nsw-aboriginal-yellow-350: var(--nsw-aboriginal-yellow-350);
  --color-nsw-aboriginal-yellow-400: var(--nsw-aboriginal-yellow-400);
  --color-nsw-aboriginal-yellow-450: var(--nsw-aboriginal-yellow-450);
  --color-nsw-aboriginal-yellow-500: var(--nsw-aboriginal-yellow-500);
  --color-nsw-aboriginal-yellow-550: var(--nsw-aboriginal-yellow-550);
  --color-nsw-aboriginal-yellow-600: var(--nsw-aboriginal-yellow-600);
  --color-nsw-aboriginal-yellow-650: var(--nsw-aboriginal-yellow-650);
  --color-nsw-aboriginal-yellow-700: var(--nsw-aboriginal-yellow-700);
  --color-nsw-aboriginal-yellow-750: var(--nsw-aboriginal-yellow-750);
  --color-nsw-aboriginal-yellow-800: var(--nsw-aboriginal-yellow-800);
  --color-nsw-aboriginal-yellow-850: var(--nsw-aboriginal-yellow-850);
  --color-nsw-aboriginal-yellow-900: var(--nsw-aboriginal-yellow-900);
  --color-nsw-aboriginal-yellow-950: var(--nsw-aboriginal-yellow-950);
  --color-nsw-aboriginal-green-50: var(--nsw-aboriginal-green-50);
  --color-nsw-aboriginal-green-100: var(--nsw-aboriginal-green-100);
  --color-nsw-aboriginal-green-150: var(--nsw-aboriginal-green-150);
  --color-nsw-aboriginal-green-200: var(--nsw-aboriginal-green-200);
  --color-nsw-aboriginal-green-250: var(--nsw-aboriginal-green-250);
  --color-nsw-aboriginal-green-300: var(--nsw-aboriginal-green-300);
  --color-nsw-aboriginal-green-350: var(--nsw-aboriginal-green-350);
  --color-nsw-aboriginal-green-400: var(--nsw-aboriginal-green-400);
  --color-nsw-aboriginal-green-450: var(--nsw-aboriginal-green-450);
  --color-nsw-aboriginal-green-500: var(--nsw-aboriginal-green-500);
  --color-nsw-aboriginal-green-550: var(--nsw-aboriginal-green-550);
  --color-nsw-aboriginal-green-600: var(--nsw-aboriginal-green-600);
  --color-nsw-aboriginal-green-650: var(--nsw-aboriginal-green-650);
  --color-nsw-aboriginal-green-700: var(--nsw-aboriginal-green-700);
  --color-nsw-aboriginal-green-750: var(--nsw-aboriginal-green-750);
  --color-nsw-aboriginal-green-800: var(--nsw-aboriginal-green-800);
  --color-nsw-aboriginal-green-850: var(--nsw-aboriginal-green-850);
  --color-nsw-aboriginal-green-900: var(--nsw-aboriginal-green-900);
  --color-nsw-aboriginal-green-950: var(--nsw-aboriginal-green-950);
  --color-nsw-aboriginal-blue-50: var(--nsw-aboriginal-blue-50);
  --color-nsw-aboriginal-blue-100: var(--nsw-aboriginal-blue-100);
  --color-nsw-aboriginal-blue-150: var(--nsw-aboriginal-blue-150);
  --color-nsw-aboriginal-blue-200: var(--nsw-aboriginal-blue-200);
  --color-nsw-aboriginal-blue-250: var(--nsw-aboriginal-blue-250);
  --color-nsw-aboriginal-blue-300: var(--nsw-aboriginal-blue-300);
  --color-nsw-aboriginal-blue-350: var(--nsw-aboriginal-blue-350);
  --color-nsw-aboriginal-blue-400: var(--nsw-aboriginal-blue-400);
  --color-nsw-aboriginal-blue-450: var(--nsw-aboriginal-blue-450);
  --color-nsw-aboriginal-blue-500: var(--nsw-aboriginal-blue-500);
  --color-nsw-aboriginal-blue-550: var(--nsw-aboriginal-blue-550);
  --color-nsw-aboriginal-blue-600: var(--nsw-aboriginal-blue-600);
  --color-nsw-aboriginal-blue-650: var(--nsw-aboriginal-blue-650);
  --color-nsw-aboriginal-blue-700: var(--nsw-aboriginal-blue-700);
  --color-nsw-aboriginal-blue-750: var(--nsw-aboriginal-blue-750);
  --color-nsw-aboriginal-blue-800: var(--nsw-aboriginal-blue-800);
  --color-nsw-aboriginal-blue-850: var(--nsw-aboriginal-blue-850);
  --color-nsw-aboriginal-blue-900: var(--nsw-aboriginal-blue-900);
  --color-nsw-aboriginal-blue-950: var(--nsw-aboriginal-blue-950);
  --color-nsw-aboriginal-purple-50: var(--nsw-aboriginal-purple-50);
  --color-nsw-aboriginal-purple-100: var(--nsw-aboriginal-purple-100);
  --color-nsw-aboriginal-purple-150: var(--nsw-aboriginal-purple-150);
  --color-nsw-aboriginal-purple-200: var(--nsw-aboriginal-purple-200);
  --color-nsw-aboriginal-purple-250: var(--nsw-aboriginal-purple-250);
  --color-nsw-aboriginal-purple-300: var(--nsw-aboriginal-purple-300);
  --color-nsw-aboriginal-purple-350: var(--nsw-aboriginal-purple-350);
  --color-nsw-aboriginal-purple-400: var(--nsw-aboriginal-purple-400);
  --color-nsw-aboriginal-purple-450: var(--nsw-aboriginal-purple-450);
  --color-nsw-aboriginal-purple-500: var(--nsw-aboriginal-purple-500);
  --color-nsw-aboriginal-purple-550: var(--nsw-aboriginal-purple-550);
  --color-nsw-aboriginal-purple-600: var(--nsw-aboriginal-purple-600);
  --color-nsw-aboriginal-purple-650: var(--nsw-aboriginal-purple-650);
  --color-nsw-aboriginal-purple-700: var(--nsw-aboriginal-purple-700);
  --color-nsw-aboriginal-purple-750: var(--nsw-aboriginal-purple-750);
  --color-nsw-aboriginal-purple-800: var(--nsw-aboriginal-purple-800);
  --color-nsw-aboriginal-purple-850: var(--nsw-aboriginal-purple-850);
  --color-nsw-aboriginal-purple-900: var(--nsw-aboriginal-purple-900);
  --color-nsw-aboriginal-purple-950: var(--nsw-aboriginal-purple-950);
  --color-success-50: var(--success-50);
  --color-success-100: var(--success-100);
  --color-success-150: var(--success-150);
  --color-success-200: var(--success-200);
  --color-success-250: var(--success-250);
  --color-success-300: var(--success-300);
  --color-success-350: var(--success-350);
  --color-success-400: var(--success-400);
  --color-success-450: var(--success-450);
  --color-success-500: var(--success-500);
  --color-success-550: var(--success-550);
  --color-success-600: var(--success-600);
  --color-success-650: var(--success-650);
  --color-success-700: var(--success-700);
  --color-success-750: var(--success-750);
  --color-success-800: var(--success-800);
  --color-success-850: var(--success-850);
  --color-success-900: var(--success-900);
  --color-success-950: var(--success-950);
  --color-warning-50: var(--warning-50);
  --color-warning-100: var(--warning-100);
  --color-warning-150: var(--warning-150);
  --color-warning-200: var(--warning-200);
  --color-warning-250: var(--warning-250);
  --color-warning-300: var(--warning-300);
  --color-warning-350: var(--warning-350);
  --color-warning-400: var(--warning-400);
  --color-warning-450: var(--warning-450);
  --color-warning-500: var(--warning-500);
  --color-warning-550: var(--warning-550);
  --color-warning-600: var(--warning-600);
  --color-warning-650: var(--warning-650);
  --color-warning-700: var(--warning-700);
  --color-warning-750: var(--warning-750);
  --color-warning-800: var(--warning-800);
  --color-warning-850: var(--warning-850);
  --color-warning-900: var(--warning-900);
  --color-warning-950: var(--warning-950);
  --color-danger-50: var(--danger-50);
  --color-danger-100: var(--danger-100);
  --color-danger-150: var(--danger-150);
  --color-danger-200: var(--danger-200);
  --color-danger-250: var(--danger-250);
  --color-danger-300: var(--danger-300);
  --color-danger-350: var(--danger-350);
  --color-danger-400: var(--danger-400);
  --color-danger-450: var(--danger-450);
  --color-danger-500: var(--danger-500);
  --color-danger-550: var(--danger-550);
  --color-danger-600: var(--danger-600);
  --color-danger-650: var(--danger-650);
  --color-danger-700: var(--danger-700);
  --color-danger-750: var(--danger-750);
  --color-danger-800: var(--danger-800);
  --color-danger-850: var(--danger-850);
  --color-danger-900: var(--danger-900);
  --color-danger-950: var(--danger-950);
  --color-info-50: var(--info-50);
  --color-info-100: var(--info-100);
  --color-info-150: var(--info-150);
  --color-info-200: var(--info-200);
  --color-info-250: var(--info-250);
  --color-info-300: var(--info-300);
  --color-info-350: var(--info-350);
  --color-info-400: var(--info-400);
  --color-info-450: var(--info-450);
  --color-info-500: var(--info-500);
  --color-info-550: var(--info-550);
  --color-info-600: var(--info-600);
  --color-info-650: var(--info-650);
  --color-info-700: var(--info-700);
  --color-info-750: var(--info-750);
  --color-info-800: var(--info-800);
  --color-info-850: var(--info-850);
  --color-info-900: var(--info-900);
  --color-info-950: var(--info-950);
  --color-white: var(--white);
  --color-black: var(--black);
}

:root {
  --nsw-grey-50: #fafafa;
  --nsw-grey-100: #f5f5f5;
  --nsw-grey-150: #f0f0f0;
  --nsw-grey-200: #ebebeb;
  --nsw-grey-250: #e3e5e6;
  --nsw-grey-300: #dcdfe0;
  --nsw-grey-350: #d4d9db;
  --nsw-grey-400: #cdd3d6;
  --nsw-grey-450: #aab0b4;
  --nsw-grey-500: #888f92;
  --nsw-grey-550: #686f72;
  --nsw-grey-600: #495054;
  --nsw-grey-650: #3f4549;
  --nsw-grey-700: #353b3f;
  --nsw-grey-750: #2b3135;
  --nsw-grey-800: #22272b;
  --nsw-grey-850: #181c1f;
  --nsw-grey-900: #0e1113;
  --nsw-grey-950: #050709;
  --nsw-green-50: #f5fff6;
  --nsw-green-100: #ecfdee;
  --nsw-green-150: #e4fce7;
  --nsw-green-200: #dbfadf;
  --nsw-green-250: #cff7d4;
  --nsw-green-300: #c2f4c9;
  --nsw-green-350: #b5f0be;
  --nsw-green-400: #a8edb3;
  --nsw-green-450: #8adc98;
  --nsw-green-500: #6acc7d;
  --nsw-green-550: #45bb62;
  --nsw-green-600: #00aa45;
  --nsw-green-650: #078e32;
  --nsw-green-700: #077320;
  --nsw-green-750: #03590f;
  --nsw-green-800: #004000;
  --nsw-green-850: #003000;
  --nsw-green-900: #002000;
  --nsw-green-950: #001100;
  --nsw-teal-50: #f2fbfa;
  --nsw-teal-100: #e7f7f5;
  --nsw-teal-150: #dcf2ef;
  --nsw-teal-200: #d1eeea;
  --nsw-teal-250: #c1eae7;
  --nsw-teal-300: #afe5e5;
  --nsw-teal-350: #9ee0e5;
  --nsw-teal-400: #8cdbe5;
  --nsw-teal-450: #75c4cf;
  --nsw-teal-500: #5eacb9;
  --nsw-teal-550: #4696a3;
  --nsw-teal-600: #2e808e;
  --nsw-teal-650: #256f7b;
  --nsw-teal-700: #1c5f69;
  --nsw-teal-750: #144e58;
  --nsw-teal-800: #0b3f47;
  --nsw-teal-850: #042f35;
  --nsw-teal-900: #011f24;
  --nsw-teal-950: #001114;
  --nsw-blue-50: #f0fbff;
  --nsw-blue-100: #e4f6ff;
  --nsw-blue-150: #d7f2fe;
  --nsw-blue-200: #cbedfd;
  --nsw-blue-250: #bceafe;
  --nsw-blue-300: #ade7ff;
  --nsw-blue-350: #9de3ff;
  --nsw-blue-400: #8ce0ff;
  --nsw-blue-450: #5ac9ff;
  --nsw-blue-500: #26aeff;
  --nsw-blue-550: #008fff;
  --nsw-blue-600: #146cfd;
  --nsw-blue-650: #0c5ad4;
  --nsw-blue-700: #0548ad;
  --nsw-blue-750: #023688;
  --nsw-blue-800: #002664;
  --nsw-blue-850: #001a4d;
  --nsw-blue-900: #001037;
  --nsw-blue-950: #000622;
  --nsw-purple-50: #f9f7ff;
  --nsw-purple-100: #f2f0ff;
  --nsw-purple-150: #ece8fe;
  --nsw-purple-200: #e6e1fd;
  --nsw-purple-250: #e0d9fe;
  --nsw-purple-300: #dad0fe;
  --nsw-purple-350: #d4c8ff;
  --nsw-purple-400: #cebfff;
  --nsw-purple-450: #baa6fc;
  --nsw-purple-500: #a68df9;
  --nsw-purple-550: #9372f5;
  --nsw-purple-600: #8055f1;
  --nsw-purple-650: #7243cf;
  --nsw-purple-700: #6432ae;
  --nsw-purple-750: #54218e;
  --nsw-purple-800: #441170;
  --nsw-purple-850: #330856;
  --nsw-purple-900: #23023e;
  --nsw-purple-950: #130027;
  --nsw-fuchsia-50: #fff6fd;
  --nsw-fuchsia-100: #ffeef9;
  --nsw-fuchsia-150: #fee6f6;
  --nsw-fuchsia-200: #fddef2;
  --nsw-fuchsia-250: #fbd4ef;
  --nsw-fuchsia-300: #f9c9eb;
  --nsw-fuchsia-350: #f7bfe9;
  --nsw-fuchsia-400: #f4b5e6;
  --nsw-fuchsia-450: #ef96da;
  --nsw-fuchsia-500: #e975cc;
  --nsw-fuchsia-550: #e150be;
  --nsw-fuchsia-600: #d912ae;
  --nsw-fuchsia-650: #bb0c94;
  --nsw-fuchsia-700: #9d067b;
  --nsw-fuchsia-750: #810264;
  --nsw-fuchsia-800: #65004d;
  --nsw-fuchsia-850: #4d003a;
  --nsw-fuchsia-900: #370028;
  --nsw-fuchsia-950: #220017;
  --nsw-red-50: #fff8f9;
  --nsw-red-100: #fff2f4;
  --nsw-red-150: #ffecef;
  --nsw-red-200: #ffe6ea;
  --nsw-red-250: #ffdbe0;
  --nsw-red-300: #ffcfd6;
  --nsw-red-350: #ffc4cc;
  --nsw-red-400: #ffb8c1;
  --nsw-red-450: #f897a2;
  --nsw-red-500: #ef7581;
  --nsw-red-550: #e44f5f;
  --nsw-red-600: #d7153a;
  --nsw-red-650: #b90e32;
  --nsw-red-700: #9b072a;
  --nsw-red-750: #7e0322;
  --nsw-red-800: #630019;
  --nsw-red-850: #4c0010;
  --nsw-red-900: #360008;
  --nsw-red-950: #210003;
  --nsw-orange-50: #fffaf6;
  --nsw-orange-100: #fff6ee;
  --nsw-orange-150: #fef1e7;
  --nsw-orange-200: #fdeddf;
  --nsw-orange-250: #fee5ce;
  --nsw-orange-300: #ffddbd;
  --nsw-orange-350: #ffd6ab;
  --nsw-orange-400: #ffce99;
  --nsw-orange-450: #fdb678;
  --nsw-orange-500: #fb9d58;
  --nsw-orange-550: #f78139;
  --nsw-orange-600: #f3631b;
  --nsw-orange-650: #db5115;
  --nsw-orange-700: #c33f0e;
  --nsw-orange-750: #ab2e06;
  --nsw-orange-800: #941b00;
  --nsw-orange-850: #730f00;
  --nsw-orange-900: #530400;
  --nsw-orange-950: #350000;
  --nsw-yellow-50: #fffcf0;
  --nsw-yellow-100: #fffae5;
  --nsw-yellow-150: #fff7da;
  --nsw-yellow-200: #fff4cf;
  --nsw-yellow-250: #fff1c2;
  --nsw-yellow-300: #feeeb5;
  --nsw-yellow-350: #feeaa8;
  --nsw-yellow-400: #fde79a;
  --nsw-yellow-450: #fbda80;
  --nsw-yellow-500: #facd63;
  --nsw-yellow-550: #fabe42;
  --nsw-yellow-600: #faaf05;
  --nsw-yellow-650: #d49403;
  --nsw-yellow-700: #af7a01;
  --nsw-yellow-750: #8b6000;
  --nsw-yellow-800: #694800;
  --nsw-yellow-850: #503500;
  --nsw-yellow-900: #392400;
  --nsw-yellow-950: #221300;
  --nsw-brown-50: #fbf8f4;
  --nsw-brown-100: #f6f1ea;
  --nsw-brown-150: #f2eae1;
  --nsw-brown-200: #ede3d7;
  --nsw-brown-250: #ecdece;
  --nsw-brown-300: #eadac6;
  --nsw-brown-350: #e9d5bd;
  --nsw-brown-400: #e8d0b5;
  --nsw-brown-450: #dbbf9f;
  --nsw-brown-500: #cfae89;
  --nsw-brown-550: #c29d73;
  --nsw-brown-600: #b68d5d;
  --nsw-brown-650: #9c764b;
  --nsw-brown-700: #82603a;
  --nsw-brown-750: #6a4b29;
  --nsw-brown-800: #523719;
  --nsw-brown-850: #3e280f;
  --nsw-brown-900: #2b1a07;
  --nsw-brown-950: #190d02;
  --nsw-aboriginal-grey-50: #f9f8f7;
  --nsw-aboriginal-grey-100: #f2f1ef;
  --nsw-aboriginal-grey-150: #ebeae8;
  --nsw-aboriginal-grey-200: #e5e3e0;
  --nsw-aboriginal-grey-250: #dfdcd8;
  --nsw-aboriginal-grey-300: #d8d4d1;
  --nsw-aboriginal-grey-350: #d2cdc9;
  --nsw-aboriginal-grey-400: #ccc6c2;
  --nsw-aboriginal-grey-450: #ada8a5;
  --nsw-aboriginal-grey-500: #8e8b8a;
  --nsw-aboriginal-grey-550: #71706f;
  --nsw-aboriginal-grey-600: #555555;
  --nsw-aboriginal-grey-650: #494949;
  --nsw-aboriginal-grey-700: #3d3d3d;
  --nsw-aboriginal-grey-750: #323232;
  --nsw-aboriginal-grey-800: #272727;
  --nsw-aboriginal-grey-850: #1c1c1c;
  --nsw-aboriginal-grey-900: #111111;
  --nsw-aboriginal-grey-950: #070707;
  --nsw-aboriginal-red-50: #fff5f5;
  --nsw-aboriginal-red-100: #ffebeb;
  --nsw-aboriginal-red-150: #fee2e2;
  --nsw-aboriginal-red-200: #fdd9d9;
  --nsw-aboriginal-red-250: #fdd0d0;
  --nsw-aboriginal-red-300: #fcc7c6;
  --nsw-aboriginal-red-350: #fcbdbd;
  --nsw-aboriginal-red-400: #fbb4b3;
  --nsw-aboriginal-red-450: #f79693;
  --nsw-aboriginal-red-500: #f27771;
  --nsw-aboriginal-red-550: #ea554c;
  --nsw-aboriginal-red-600: #e1261c;
  --nsw-aboriginal-red-650: #cd1f17;
  --nsw-aboriginal-red-700: #ba1811;
  --nsw-aboriginal-red-750: #a7110b;
  --nsw-aboriginal-red-800: #950906;
  --nsw-aboriginal-red-850: #740001;
  --nsw-aboriginal-red-900: #540000;
  --nsw-aboriginal-red-950: #360000;
  --nsw-aboriginal-orange-50: #fff4ec;
  --nsw-aboriginal-orange-100: #fee9dd;
  --nsw-aboriginal-orange-150: #fcdfcd;
  --nsw-aboriginal-orange-200: #f9d4be;
  --nsw-aboriginal-orange-250: #f8caae;
  --nsw-aboriginal-orange-300: #f7bf9e;
  --nsw-aboriginal-orange-350: #f6b58e;
  --nsw-aboriginal-orange-400: #f4aa7d;
  --nsw-aboriginal-orange-450: #f39a66;
  --nsw-aboriginal-orange-500: #f2894f;
  --nsw-aboriginal-orange-550: #f07736;
  --nsw-aboriginal-orange-600: #ee6314;
  --nsw-aboriginal-orange-650: #d45310;
  --nsw-aboriginal-orange-700: #ba440a;
  --nsw-aboriginal-orange-750: #a13505;
  --nsw-aboriginal-orange-800: #882600;
  --nsw-aboriginal-orange-850: #691900;
  --nsw-aboriginal-orange-900: #4c0d00;
  --nsw-aboriginal-orange-950: #300300;
  --nsw-aboriginal-brown-50: #fcf1e9;
  --nsw-aboriginal-brown-100: #f6e3d7;
  --nsw-aboriginal-brown-150: #efd5c4;
  --nsw-aboriginal-brown-200: #e9c8b2;
  --nsw-aboriginal-brown-250: #e4ba9f;
  --nsw-aboriginal-brown-300: #dead8c;
  --nsw-aboriginal-brown-350: #d99f78;
  --nsw-aboriginal-brown-400: #d39165;
  --nsw-aboriginal-brown-450: #c68158;
  --nsw-aboriginal-brown-500: #b9724b;
  --nsw-aboriginal-brown-550: #ab623e;
  --nsw-aboriginal-brown-600: #9e5332;
  --nsw-aboriginal-brown-650: #8b4627;
  --nsw-aboriginal-brown-700: #79391c;
  --nsw-aboriginal-brown-750: #672d10;
  --nsw-aboriginal-brown-800: #552105;
  --nsw-aboriginal-brown-850: #411602;
  --nsw-aboriginal-brown-900: #2d0c00;
  --nsw-aboriginal-brown-950: #1b0400;
  --nsw-aboriginal-yellow-50: #fffcee;
  --nsw-aboriginal-yellow-100: #fff8e0;
  --nsw-aboriginal-yellow-150: #fff5d3;
  --nsw-aboriginal-yellow-200: #fff1c5;
  --nsw-aboriginal-yellow-250: #ffeeb7;
  --nsw-aboriginal-yellow-300: #ffeba9;
  --nsw-aboriginal-yellow-350: #fee79b;
  --nsw-aboriginal-yellow-400: #fee48c;
  --nsw-aboriginal-yellow-450: #fed675;
  --nsw-aboriginal-yellow-500: #fec85d;
  --nsw-aboriginal-yellow-550: #feb944;
  --nsw-aboriginal-yellow-600: #fea927;
  --nsw-aboriginal-yellow-650: #df961c;
  --nsw-aboriginal-yellow-700: #c18312;
  --nsw-aboriginal-yellow-750: #a57007;
  --nsw-aboriginal-yellow-800: #895e00;
  --nsw-aboriginal-yellow-850: #694700;
  --nsw-aboriginal-yellow-900: #4c3000;
  --nsw-aboriginal-yellow-950: #2f1c00;
  --nsw-aboriginal-green-50: #f5f9f2;
  --nsw-aboriginal-green-100: #ecf3e7;
  --nsw-aboriginal-green-150: #e3ecdc;
  --nsw-aboriginal-green-200: #dae6d1;
  --nsw-aboriginal-green-250: #d1e0c6;
  --nsw-aboriginal-green-300: #c7d9ba;
  --nsw-aboriginal-green-350: #bed3af;
  --nsw-aboriginal-green-400: #b5cda4;
  --nsw-aboriginal-green-450: #a5c28e;
  --nsw-aboriginal-green-500: #95b777;
  --nsw-aboriginal-green-550: #86ac60;
  --nsw-aboriginal-green-600: #78a146;
  --nsw-aboriginal-green-650: #5f8f44;
  --nsw-aboriginal-green-700: #497d40;
  --nsw-aboriginal-green-750: #346a3b;
  --nsw-aboriginal-green-800: #215834;
  --nsw-aboriginal-green-850: #154225;
  --nsw-aboriginal-green-900: #0a2e17;
  --nsw-aboriginal-green-950: #021b0a;
  --nsw-aboriginal-blue-50: #eef8fa;
  --nsw-aboriginal-blue-100: #dff1f4;
  --nsw-aboriginal-blue-150: #d0e9ee;
  --nsw-aboriginal-blue-200: #c1e2e8;
  --nsw-aboriginal-blue-250: #b2dbe2;
  --nsw-aboriginal-blue-300: #a3d4dc;
  --nsw-aboriginal-blue-350: #94ccd7;
  --nsw-aboriginal-blue-400: #84c5d1;
  --nsw-aboriginal-blue-450: #67aec0;
  --nsw-aboriginal-blue-500: #4a96b0;
  --nsw-aboriginal-blue-550: #2e7fa1;
  --nsw-aboriginal-blue-600: #0d6791;
  --nsw-aboriginal-blue-650: #095d84;
  --nsw-aboriginal-blue-700: #055377;
  --nsw-aboriginal-blue-750: #02496a;
  --nsw-aboriginal-blue-800: #00405e;
  --nsw-aboriginal-blue-850: #002f48;
  --nsw-aboriginal-blue-900: #002033;
  --nsw-aboriginal-blue-950: #00111f;
  --nsw-aboriginal-purple-50: #faf1f8;
  --nsw-aboriginal-purple-100: #f2e5f0;
  --nsw-aboriginal-purple-150: #ebd8e8;
  --nsw-aboriginal-purple-200: #e4cce0;
  --nsw-aboriginal-purple-250: #ddbfd8;
  --nsw-aboriginal-purple-300: #d7b3d1;
  --nsw-aboriginal-purple-350: #d0a6c9;
  --nsw-aboriginal-purple-400: #c99ac2;
  --nsw-aboriginal-purple-450: #bd8bb6;
  --nsw-aboriginal-purple-500: #b17caa;
  --nsw-aboriginal-purple-550: #a66d9f;
  --nsw-aboriginal-purple-600: #9a5e93;
  --nsw-aboriginal-purple-650: #844f7e;
  --nsw-aboriginal-purple-700: #6f4169;
  --nsw-aboriginal-purple-750: #5b3355;
  --nsw-aboriginal-purple-800: #472642;
  --nsw-aboriginal-purple-850: #351a31;
  --nsw-aboriginal-purple-900: #241021;
  --nsw-aboriginal-purple-950: #150612;
  --success-50: #eff9ed;
  --success-100: #e0f3de;
  --success-150: #d2eccf;
  --success-200: #c4e5c0;
  --success-250: #aad6a5;
  --success-300: #8fc78a;
  --success-350: #74b76f;
  --success-400: #58a854;
  --success-450: #49a146;
  --success-500: #399936;
  --success-550: #259224;
  --success-600: #008a07;
  --success-650: #007204;
  --success-700: #005a02;
  --success-750: #004401;
  --success-800: #002f00;
  --success-850: #002200;
  --success-900: #001600;
  --success-950: #000b00;
  --warning-50: #fff3ed;
  --warning-100: #ffe8de;
  --warning-150: #ffddcf;
  --warning-200: #fdd2c0;
  --warning-250: #f6bda5;
  --warning-300: #eea88a;
  --warning-350: #e6936f;
  --warning-400: #dd7d53;
  --warning-450: #d87244;
  --warning-500: #d36734;
  --warning-550: #ce5c21;
  --warning-600: #c95000;
  --warning-650: #a83f03;
  --warning-700: #882f03;
  --warning-750: #692001;
  --warning-800: #4b1200;
  --warning-850: #390a00;
  --warning-900: #270400;
  --warning-950: #170100;
  --danger-50: #fff0ef;
  --danger-100: #ffe2e1;
  --danger-150: #ffd4d4;
  --danger-200: #fdc6c6;
  --danger-250: #f4acad;
  --danger-300: #ea9294;
  --danger-350: #df787c;
  --danger-400: #d35d65;
  --danger-450: #cd4e59;
  --danger-500: #c63f4e;
  --danger-550: #bf2c42;
  --danger-600: #b81237;
  --danger-650: #990b2a;
  --danger-700: #7c061f;
  --danger-750: #5f0214;
  --danger-800: #44000a;
  --danger-850: #330005;
  --danger-900: #230002;
  --danger-950: #140001;
  --info-50: #e9eef7;
  --info-100: #d4ddeb;
  --info-150: #c0cce0;
  --info-200: #acbbd5;
  --info-250: #96a9cc;
  --info-300: #8098c2;
  --info-350: #6b86b8;
  --info-400: #5775ae;
  --info-450: #4d6ca9;
  --info-500: #4264a4;
  --info-550: #385b9e;
  --info-600: #2e5299;
  --info-650: #23427f;
  --info-700: #193366;
  --info-750: #10254f;
  --info-800: #071738;
  --info-850: #040f2a;
  --info-900: #02071c;
  --info-950: #00030f;
  --white: #ffffff;
  --black: #000000;
}
